var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	60332: () => (loadSingletonVersion("default", "@angular/core-angular-17", false, [1,"auto"], () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(37580))))))),
	63446: () => (loadSingletonVersion("default", "@angular/common-angular-17", false, [1,"auto"], () => (__webpack_require__.e(316).then(() => (() => (__webpack_require__(60316))))))),
	49427: () => (loadSingletonVersion("default", "rxjs/operators-angular-17", false, [1,"auto"], () => (__webpack_require__.e(3620).then(() => (() => (__webpack_require__(23620))))))),
	93539: () => (loadSingletonVersion("default", "rxjs-angular-17", false, [1,"auto"], () => (__webpack_require__.e(1340).then(() => (() => (__webpack_require__(31340))))))),
	34880: () => (loadSingletonVersion("default", "@angular/core/primitives/signals-angular-17", false, [1,"auto"], () => (__webpack_require__.e(5689).then(() => (() => (__webpack_require__(85689))))))),
	48056: () => (loadSingletonVersion("default", "@angular/common/http-angular-17", false, [1,"auto"], () => (__webpack_require__.e(8824).then(() => (() => (__webpack_require__(46443))))))),
	77005: () => (loadSingletonVersion("default", "@angular/platform-browser-angular-17", false, [1,"auto"], () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(80436))))))),
	25872: () => (loadSingletonVersion("default", "@angular/animations-angular-17", false, [1,"auto"], () => (__webpack_require__.e(7172).then(() => (() => (__webpack_require__(47172))))))),
	30288: () => (loadSingletonVersion("default", "@angular/core/rxjs-interop-angular-17", false, [1,"auto"], () => (__webpack_require__.e(9074).then(() => (() => (__webpack_require__(49074))))))),
	57482: () => (loadSingletonVersion("default", "@angular/router-angular-17", false, [1,"auto"], () => (__webpack_require__.e(2691).then(() => (() => (__webpack_require__(95072))))))),
	62572: () => (loadSingletonVersion("default", "@angular/forms-angular-17", false, [1,"auto"], () => (__webpack_require__.e(4456).then(() => (() => (__webpack_require__(34456))))))),
	71931: () => (loadSingletonVersion("default", "@aw/ads-components/aw-material-icons-angular-17", false, [1,"auto"], () => (__webpack_require__.e(1546).then(() => (() => (__webpack_require__(59165))))))),
	86995: () => (loadSingletonVersion("default", "@aw/ads-components/aw-spinner-angular-17", false, [1,"auto"], () => (__webpack_require__.e(5777).then(() => (() => (__webpack_require__(75777))))))),
	12147: () => (loadSingletonVersion("default", "@aw/ads-components/aw-menu-angular-17", false, [1,"auto"], () => (__webpack_require__.e(9981).then(() => (() => (__webpack_require__(62362))))))),
	59383: () => (loadSingletonVersion("default", "@aw/ads-components/aw-button-angular-17", false, [1,"auto"], () => (__webpack_require__.e(7884).then(() => (() => (__webpack_require__(75503))))))),
	45475: () => (loadSingletonVersion("default", "@aw/ads-components/aw-avatar-angular-17", false, [1,"auto"], () => (__webpack_require__.e(9563).then(() => (() => (__webpack_require__(41944))))))),
	73839: () => (loadSingletonVersion("default", "@aw/ads-components/aw-badge-angular-17", false, [1,"auto"], () => (__webpack_require__.e(435).then(() => (() => (__webpack_require__(62816))))))),
	3351: () => (loadSingletonVersion("default", "@aw/ads-components/aw-textarea-angular-17", false, [1,"auto"], () => (__webpack_require__.e(2830).then(() => (() => (__webpack_require__(50449))))))),
	5905: () => (loadSingletonVersion("default", "@angular/cdk-angular-17", false, [1,"auto"], () => (__webpack_require__.e(1398).then(() => (() => (__webpack_require__(31398))))))),
	33635: () => (loadSingletonVersion("default", "@aw/ads-components/aw-anchor-angular-17", false, [1,"auto"], () => (__webpack_require__.e(91).then(() => (() => (__webpack_require__(62472))))))),
	9263: () => (loadSingletonVersion("default", "tslib-angular-17", false, [1,"auto"], () => (__webpack_require__.e(4398).then(() => (() => (__webpack_require__(24398)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"91": [
		57482
	],
	"164": [
		25872,
		30288,
		49427,
		59383,
		60332,
		62572,
		63446,
		71931,
		86995,
		93539
	],
	"436": [
		48056,
		60332,
		63446
	],
	"449": [
		25872,
		30288,
		49427,
		59383,
		60332,
		62572,
		63446,
		71931,
		93539
	],
	"677": [
		25872,
		30288,
		45475,
		49427,
		57482,
		59383,
		60332,
		63446,
		71931,
		73839,
		86995,
		93539
	],
	"979": [
		25872,
		30288,
		60332,
		62572,
		63446,
		71931,
		93539
	],
	"1340": [
		9263
	],
	"1944": [
		30288,
		60332,
		63446,
		71931,
		93539
	],
	"2075": [
		49427,
		60332,
		63446,
		93539
	],
	"2168": [
		30288,
		60332,
		63446,
		93539
	],
	"2362": [
		25872,
		30288,
		49427,
		60332,
		63446,
		71931,
		93539
	],
	"2472": [
		25872,
		30288,
		57482,
		60332,
		62572,
		63446,
		93539
	],
	"2691": [
		49427,
		77005
	],
	"2816": [
		60332,
		63446,
		93539
	],
	"3002": [
		12147,
		25872,
		30288,
		59383,
		60332,
		63446,
		71931,
		93539
	],
	"3620": [
		9263
	],
	"4456": [
		49427
	],
	"4606": [
		12147,
		25872,
		30288,
		45475,
		59383,
		60332,
		63446,
		71931,
		73839,
		93539
	],
	"4791": [
		60332,
		63446
	],
	"5072": [
		49427,
		60332,
		63446,
		77005,
		93539
	],
	"5503": [
		25872,
		30288,
		57482,
		60332,
		63446,
		71931,
		86995,
		93539
	],
	"6443": [
		49427,
		60332,
		63446,
		93539
	],
	"6693": [
		49427,
		60332,
		93539
	],
	"7580": [
		34880,
		49427,
		93539
	],
	"7884": [
		57482,
		86995
	],
	"7935": [
		60332
	],
	"8055": [
		48056
	],
	"8158": [
		60332,
		63446,
		93539
	],
	"8321": [
		3351,
		5905,
		25872,
		30288,
		33635,
		48056,
		49427,
		59383,
		60332,
		62572,
		63446,
		71931,
		93539
	],
	"8824": [
		49427,
		93539
	],
	"9017": [
		60332
	],
	"9074": [
		49427
	],
	"9165": [
		30288,
		60332,
		63446,
		93539
	],
	"9981": [
		49427
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}